import { projectAtom, updateCurrentProject } from "../project/projects-state"
import { atomWithStorage } from "jotai/utils"
import { atom } from "jotai"
import { safeJSONLocalStorage } from "@/utils/safe-jotai-storage"

export const workspaceIdAtom = atomWithStorage<string | null>(
	"pixieset_workspace",
	null,
	safeJSONLocalStorage<string | null>(),
)
export const collectionIdAtom = atom((get) => {
	return get(projectAtom)?.publishCollectionId
})

export const galleryIdAtom = atom(
	(get) => {
		return get(projectAtom)?.publishGalleryId
	},
	(_, _set, galleryId: string | null) => {
		void updateCurrentProject({ publishGalleryId: galleryId ?? undefined })
	},
)

export const isPhotoStorageAvailableAtom = atom<boolean | undefined>(undefined)
